import React from 'react';

const DOT = { connected: '#16a34a', connecting: '#ca8a04', reconnecting: '#ca8a04', disconnected: '#9ca3af' };

export default function StatusBar({ sessionId, status, theme }) {
  const color = DOT[status.split('…')[0]] || '#9ca3af';
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginBottom: 16 }}>
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: color, display: 'inline-block' }} />
      <span style={{ fontSize: 13, color: theme.textSub }}>
        {sessionId ? `Session ${sessionId}  ·  ` : ''}{status}
      </span>
    </div>
  );
}
